import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=f98e1fca&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98e1fca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f98e1fca')) {
      api.createRecord('f98e1fca', component.options)
    } else {
      api.reload('f98e1fca', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=f98e1fca&scoped=true&", function () {
      api.rerender('f98e1fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FmzVCxiUafDv/JS/comp/Voucher-Unit.vue"
export default component.exports